import { useEffect, useState } from "react";
import { Select, Tag } from "antd";
import { t } from "i18next";
import ApiService from "../../core/service/api-service";

/**
 * Çekim listesi seçici (çoklu). Filtre çubuğunda ve gerekirse başka yerlerde kullanılır.
 *
 * Backend zaten YALNIZ görünür listeleri döndürür (§2.1) — burada ayrıca eleme yapılmaz,
 * görünürlük kuralının tek kaynağı sunucudur.
 */
export default function StudyListSelect({ onListLoaded, ...props }) {
    const [lists, setLists] = useState([])

    const getLists = async () => {
        const res = await ApiService.StudyList.GetList();
        if (res.success) {
            setLists(res.data || [])
            onListLoaded && onListLoaded(res.data || [])
        }
    }

    useEffect(() => {
        getLists()
    }, [])

    return (
        <Select
            mode={'multiple'}
            allowClear={true}
            optionFilterProp={'label'}
            placeholder={t('Select list')}
            notFoundContent={t('No list yet')}
            {...props}
        >
            {
                lists.map(x => (
                    <Select.Option key={x.id} value={x.id} label={x.name}>
                        <span>{x.name}</span>
                        {!x.isPublic && (
                            <Tag style={{ marginLeft: 6 }}>{t('Private')}</Tag>
                        )}
                    </Select.Option>
                ))
            }
        </Select>
    )
}
